import { Component } from 'react'
import type { ReactNode } from 'react'
import { AlertCircle } from 'lucide-react'

interface Props { children: ReactNode }
interface State { hasError: boolean; message: string }

export default class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message }
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        <div className="w-16 h-16 rounded-2xl bg-[var(--surface-hover)] flex items-center justify-center mb-4">
          <AlertCircle className="h-8 w-8 text-[var(--status-error-text)]" />
        </div>
        <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">Something went wrong</h2>
        <p className="text-sm text-[var(--text-secondary)] max-w-sm mb-6">{this.state.message || 'An unexpected error occurred.'}</p>
        <button
          type="button"
          onClick={() => { this.setState({ hasError: false, message: '' }); window.location.reload() }}
          className="inline-flex items-center px-4 py-2 rounded-lg bg-[var(--brand-primary)] text-[var(--text-on-brand)] text-sm font-medium hover:opacity-90 transition-opacity cursor-pointer"
        >
          Reload page
        </button>
      </div>
    )
  }
}
